if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;

        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.querySelector('.sticky-atc__label');
        this.price = this.querySelector('.sticky-atc__price');
        this.dataNode = this.querySelector('[data-sticky-atc-data]');
        this.productData = this.getProductData();

        this.handleInteraction = this.handleInteraction.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.sync = this.sync.bind(this);

        this.button?.addEventListener('click', this.handleClick);
        this.productInfo.addEventListener('input', this.handleInteraction);
        this.productInfo.addEventListener('change', this.handleInteraction);

        this.createObservers();

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.sectionId !== this.productInfo.sectionId) return;
            this.sync();
          });

          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
            this.sync();
          });
        }

        requestAnimationFrame(this.sync);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.productInfo?.removeEventListener('input', this.handleInteraction);
        this.productInfo?.removeEventListener('change', this.handleInteraction);
        this.submitButtonObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.quantityUpdateUnsubscriber?.();
      }

      getProductData() {
        try {
          return JSON.parse(this.dataNode.textContent);
        } catch (error) {
          console.error('Sticky ATC data error:', error);
          return {
            moneyFormat: '${{amount}}',
            variants: [],
          };
        }
      }

      get submitButton() {
        return this.productInfo.querySelector(`#ProductSubmitButton-${this.sectionId}`);
      }

      get variantIdInput() {
        return this.productInfo.querySelector(`#product-form-${this.sectionId} input[name="id"]`);
      }

      get quantityInput() {
        return (
          this.productInfo.querySelector(`#Quantity-${this.sectionId}`) ||
          this.productInfo.querySelector('.quantity__input')
        );
      }

      get selectedVariant() {
        const currentVariantId = Number(this.variantIdInput?.value);
        return this.productData.variants.find((variant) => Number(variant.id) === currentVariantId) || null;
      }

      get selectedQuantity() {
        const quantity = Number(this.quantityInput?.value);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      createObservers() {
        if (!this.submitButton) return;

        this.submitButtonObserver = new MutationObserver(() => this.sync());
        this.submitButtonObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      handleInteraction() {
        this.sync();
      }

      handleClick(event) {
        event.preventDefault();

        const submitButton = this.submitButton;
        if (!submitButton || submitButton.disabled) return;

        submitButton.click();
      }

      sync() {
        this.syncButton();
        this.syncPrice();
      }

      syncButton() {
        const submitButton = this.submitButton;
        if (!submitButton || !this.button) return;

        const labelText =
          submitButton.querySelector(':scope > span')?.textContent?.trim() ||
          submitButton.textContent?.trim() ||
          '';

        this.label.textContent = labelText;
        this.button.disabled = submitButton.disabled;

        this.button.classList.toggle('button--secondary', submitButton.classList.contains('button--secondary'));
        this.button.classList.toggle('button--primary', !submitButton.classList.contains('button--secondary'));
      }

      syncPrice() {
        if (!this.price) return;

        const variant = this.selectedVariant;
        if (!variant) {
          this.price.textContent = '';
          return;
        }

        const total = variant.price * this.selectedQuantity;
        this.price.innerHTML = this.formatMoney(total);
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, this.productData.moneyFormat);
        }

        return `${(cents / 100).toFixed(2).replace('.', ',')}€`;
      }
    }
  );
}